import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

const triggerClass =
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all";

export function EmployeeSubNav() {
  return (
    <div className={cn("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", "flex flex-wrap h-auto")}>
      <NavLink
        to="/employee/clock"
        end
        data-testid="nav-employee-clock"
        className={({ isActive }) =>
          cn(triggerClass, isActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")
        }
      >
        Clock
      </NavLink>
      <NavLink
        to="/employee/activity"
        data-testid="nav-employee-activity"
        className={({ isActive }) =>
          cn(triggerClass, isActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")
        }
      >
        Recent Activity
      </NavLink>
      <NavLink
        to="/employee/timecard"
        data-testid="nav-employee-timecard"
        className={({ isActive }) =>
          cn(triggerClass, isActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")
        }
      >
        Time Card
      </NavLink>
    </div>
  );
}
